import React from "react"
import { Link } from "react-static"
import Icon from "components/Icon"
import "./styles.css"

export default class List extends React.Component {
	render() {
		const { mode, datasets } = this.props

		return (
			<ul id="datasets-list">
				{datasets.map(dataset => (
					<li key={dataset.id}>
						<Link to={`/${mode}/show/${dataset.name}/`}>
							<div className="content">
								{mode === "dataset"
									? dataset.title
									: dataset.citation}
								<div className="badges">
									{dataset.hasDoi &&
										(dataset.hasSFBDoi ? (
											<span className="badge sfbdoi">
												SFB806DOI
											</span>
										) : (
											<span className="badge doi">
												DOI
											</span>
										))}
									{dataset.hasSpatial && (
										<span className="badge spatial">
											Spatial
										</span>
									)}
									{dataset.hasTemporal && (
										<span className="badge temporal">
											Temporal
										</span>
									)}
									{dataset.paleo_map === "1" && (
										<span className="badge paleomaps">
											PaleoMaps
										</span>
									)}
									{dataset.publicationstate &&
									dataset.publicationstate ===
										"peerreviewed_isiindexed" ? (
										<span className="badge peerreviewed">
											Peerreviewed (ISI-Indexed)
										</span>
									) : (
										<span className="badge peerreviewed">
											Peerreviewed
										</span>
									)}
								</div>
								<div className="meta">
									<span>
										Maintained by{" "}
										{dataset.maintainers.join(", ")}
									</span>
									<span>
										Created at{" "}
										{new Date(
											dataset.metadata_created
										).toLocaleDateString()}
									</span>
								</div>

								{mode === "dataset" && (
									<p className="abstract">
										{dataset.abstract &&
										dataset.abstract.length > 255
											? dataset.abstract.substr(0, 255) +
											  "..."
											: dataset.abstract}
									</p>
								)}
							</div>
							<div className="projects">
								{dataset.groups.split(";").map(group => (
									<i
										key={group}
										className={`sprite project${group.toUpperCase()}`}
									/>
								))}
							</div>
							<div className="attachments">
								{dataset.resources.map(r => (
									<span key={r.id}>
										<Icon name="attach" />{" "}
										{r.format === "file"
											? r.name.split(".").pop()
											: r.format}
									</span>
								))}
							</div>
						</Link>
					</li>
				))}
			</ul>
		)
	}
}



// WEBPACK FOOTER //
// /home/christian/git/pwa-crc806db/src/containers/Datasets/list.js